import { NumberFormatter } from '@bimser/components';
import { MLHelper, compareMatchWithCollection, isNullOrUndefined } from '@bimser/core';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import get from 'lodash/get';
import DataGrid from '../..';
import { IDataGridRowCollection } from '../../entities';

dayjs.extend(localizedFormat);

export function handleRowsForMobile(this: DataGrid, rows: IDataGridRowCollection) {
	const data =
		(rows || this.rows)?.reduce((result, row) => {
			const isHidden = this.hiddenRowValueMatchers?.values?.some(compareValue =>
				compareMatchWithCollection({
					value: get(row.data, this.hiddenRowColumnName),
					dataType: this.hiddenRowValueMatchers.type,
					compareValue
				})
			);
			return isHidden ? result : [...result, row];
		}, []) || [];

	function getIconName(datagrid: any, cellName: string, cellValue: string) {
		const items = datagrid?.columns.find(column => column.dbType.columnName == cellName)
			?.editControl.items;
		let iconName = '';
		if (items?.length) {
			iconName = items.find(item => item.value == cellValue)?.icon || '';
		}
		return iconName;
	}

	return (
		data.map(row => {
			const cells = row.cells?.map(cell => {
				switch (cell.editType) {
					case 'datePicker': {
						const format =
							this.columns.find(column => column.name === cell.name)?.format || 'L';
						const text = !isNullOrUndefined(cell.value)
							? dayjs(new Date(cell.value)).format(format)
							: '';
						const value = !isNullOrUndefined(cell.value) ? cell.value : '';

						return {
							...cell,
							value,
							text
						};
					}
					case 'dateTimePicker': {
						const format =
							this.columns.find(column => column.name === cell.name)?.format ||
							'L LT';
						const text = !isNullOrUndefined(cell.value)
							? dayjs(new Date(cell.value)).format(format)
							: '';
						const value = !isNullOrUndefined(cell.value) ? cell.value : '';

						return {
							...cell,
							value,
							text
						};
					}
					case 'timePicker': {
						const format =
							this.columns.find(column => column.name === cell.name)?.format || 'LTS';
						const text = !isNullOrUndefined(cell.value)
							? dayjs(cell.value).format(format)
							: '';
						const value = !isNullOrUndefined(cell.value) ? cell.value : '';

						return {
							...cell,
							value,
							text
						};
					}
					case 'comboBox': {
						const iconName = getIconName(this, cell.name, cell.value);
						const cellText =
							this.columns.find(item => item.name == cell.name)?.dbType?.type !==
							'object'
								? cell.value
								: MLHelper.getMLText(cell.text);

						return {
							...cell,
							text: cellText,
							icon: iconName
						};
					}
					case 'numberBox': {
						let text = cell.value?.toString() || '';

						const column = this.columns.find(({ name }) => name === cell.name);
						if (column) {
							const precision = column.precision || 0;
							const useThousandSeparator = column.useThousandSeparator;

							const formatter = new NumberFormatter();
							formatter.init(precision, useThousandSeparator);

							text = formatter.format(cell.value, null);
						}

						return {
							...cell,
							text
						};
					}
					case 'multiLanguageTextBox': {
						return {
							...cell,
							text: MLHelper.getMLText(cell.value) || ''
						};
					}
					case 'checkBox': {
						return {
							...cell,
							text: cell.value?.toString() || ''
						};
					}
					case 'fileSelect': {
						return {
							...cell,
							text: cell.value?.toString() || ''
						};
					}

					default:
						return cell;
				}
			});

			const rowData: any = {};

			if (row?.data) {
				Object.keys(row.data).forEach(key => {
					rowData[key] = cells.find(cell => cell.name === key)?.value || null;
				});
			} else {
				cells.forEach(cell => {
					rowData[cell.name] = cell.value || null;
				});
			}

			return {
				...row,
				cells,
				data: rowData,
				primaryKey: this.getUniqueDataField()
			};
		}) || []
	);
}
